import { c as _c } from "react/compiler-runtime";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pane, PaneContainer, PaneTitle } from "../Panes.style";
import { NextButton } from "../../shared/Buttons/NavigationButtons";
import { State } from "../../../store/state";
import { setSum, setRecurring, setCauseAreaAmount, setOperationsPercentageByCauseArea, setOrgAmount } from "../../../store/donation/actions";
import { nextPane } from "../../../store/layout/actions";
import { RecurringDonation } from "../../../types/Enums";
import { ActionBar, CauseAreasWrapper, RecurringSelectionWrapper, TotalAmountWrapper } from "../AmountPane.style";
import { AmountContext, OperationsConfig, CauseAreaDisplayConfig, UILabels, SmartDistributionContext } from "../../../types/WidgetProps";
import { CauseAreaForm } from "./CauseAreaForm";
import { SmartDistributionForm } from "./SmartDistributionForm";
import { OperationsCauseAreaForm } from "./OperationsCauseAreaForm";
import { GlobalCutToggle } from "./GlobalCutToggle";
import { useAmountCalculation } from "./useAmountCalculation";
import { thousandize } from "../../../../../../../util/formatting";
import { RadioButtonGroup } from "../../../../RadioButton/RadioButtonGroup";
import { LinkType } from "../../../../../../main/blocks/Links/Links";
import { usePrefilledCauseAreaIds } from "../../hooks";
interface AmountPaneProps {
  nextButtonText: string;
  smartDistContext: SmartDistributionContext;
  text: {
    single_donation_text: string;
    monthly_donation_text: string;
  };
  enableRecurring: boolean;
  enableSingle: boolean;
  amountContext: AmountContext;
  operationsConfig?: OperationsConfig;
  causeAreaDisplayConfig?: CauseAreaDisplayConfig;
  uiLabels?: UILabels;
}
export const AmountPane: React.FC<AmountPaneProps> = t0 => {
  const $ = _c(91);
  const {
    nextButtonText,
    smartDistContext,
    text,
    enableRecurring,
    enableSingle,
    amountContext,
    operationsConfig,
    causeAreaDisplayConfig,
    uiLabels
  } = t0;
  const dispatch = useDispatch();
  const {
    selectionType,
    selectedCauseAreaId,
    recurring,
    smartDistributionTotal,
    operationsPercentageByCauseArea: t1,
    causeAreaAmounts: t2
  } = useSelector(_temp);
  t1 === undefined ? {} : t1;
  t2 === undefined ? {} : t2;
  const causeAreas = useSelector(_temp2) || [];
  const prefilledCauseAreaIds = usePrefilledCauseAreaIds();
  const {
    totalAmount,
    causeAreaAmounts,
    orgAmounts,
    causeAreaDistributionType
  } = useAmountCalculation(selectionType || "single", selectedCauseAreaId || null, causeAreas);
  let t3;
  if ($[0] !== dispatch || $[1] !== selectedCauseAreaId || $[2] !== smartDistributionTotal || $[3] !== totalAmount) {
    t3 = () => {
      const finalAmount = selectedCauseAreaId === -1 ? smartDistributionTotal || 0 : totalAmount;
      dispatch(setSum(finalAmount));
      dispatch(nextPane());
    };
    $[0] = dispatch;
    $[1] = selectedCauseAreaId;
    $[2] = smartDistributionTotal;
    $[3] = totalAmount;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleNext = t3;
  const effectiveTotal = selectedCauseAreaId === -1 ? smartDistributionTotal || 0 : totalAmount;
  const suggestedSums = recurring ? amountContext.preset_amounts_recurring : amountContext.preset_amounts_single;
  let T0;
  let T1;
  let T2;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[5] !== causeAreaAmounts || $[6] !== causeAreaDisplayConfig || $[7] !== causeAreaDistributionType || $[8] !== causeAreas || $[9] !== dispatch || $[10] !== enableRecurring || $[11] !== enableSingle || $[12] !== operationsConfig || $[13] !== orgAmounts || $[14] !== prefilledCauseAreaIds || $[15] !== recurring || $[16] !== selectedCauseAreaId || $[17] !== selectionType || $[18] !== smartDistContext || $[19] !== suggestedSums || $[20] !== text || $[21] !== totalAmount || $[22] !== uiLabels?.total_label) {
    t7 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let t8;
      if ($[30] !== selectedCauseAreaId) {
        t8 = c => c.id === selectedCauseAreaId;
        $[30] = selectedCauseAreaId;
        $[31] = t8;
      } else {
        t8 = $[31];
      }
      const selectedCA = causeAreas.find(t8);
      if (!causeAreaDisplayConfig) {
        let t9;
        if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
          t9 = <span>Missing cause area display config</span>;
          $[32] = t9;
        } else {
          t9 = $[32];
        }
        t7 = t9;
        break bb0;
      }
      T2 = Pane;
      T1 = PaneContainer;
      const t9 = !enableSingle;
      let t10;
      if ($[33] !== t9 || $[34] !== text.single_donation_text) {
        t10 = {
          title: text.single_donation_text,
          value: RecurringDonation.NON_RECURRING,
          disabled: t9,
          data_cy: "single-donation-radio"
        };
        $[33] = t9;
        $[34] = text.single_donation_text;
        $[35] = t10;
      } else {
        t10 = $[35];
      }
      const t11 = !enableRecurring;
      let t12;
      if ($[36] !== t11 || $[37] !== text.monthly_donation_text) {
        t12 = {
          title: text.monthly_donation_text,
          value: RecurringDonation.RECURRING,
          disabled: t11,
          data_cy: "recurring-donation-radio"
        };
        $[36] = t11;
        $[37] = text.monthly_donation_text;
        $[38] = t12;
      } else {
        t12 = $[38];
      }
      let t13;
      if ($[39] !== t10 || $[40] !== t12) {
        t13 = [t10, t12];
        $[39] = t10;
        $[40] = t12;
        $[41] = t13;
      } else {
        t13 = $[41];
      }
      let t14;
      if ($[42] !== dispatch) {
        t14 = val => dispatch(setRecurring(val));
        $[42] = dispatch;
        $[43] = t14;
      } else {
        t14 = $[43];
      }
      if ($[44] !== recurring || $[45] !== t13 || $[46] !== t14) {
        t6 = <RecurringSelectionWrapper><RadioButtonGroup options={t13} selected={recurring} onSelect={t14} /></RecurringSelectionWrapper>;
        $[44] = recurring;
        $[45] = t13;
        $[46] = t14;
        $[47] = t6;
      } else {
        t6 = $[47];
      }
      T0 = CauseAreasWrapper;
      if ($[48] !== causeAreaAmounts || $[49] !== causeAreaDisplayConfig || $[50] !== causeAreaDistributionType || $[51] !== causeAreas || $[52] !== operationsConfig || $[53] !== orgAmounts || $[54] !== prefilledCauseAreaIds || $[55] !== selectedCauseAreaId || $[56] !== selectionType || $[57] !== smartDistContext || $[58] !== suggestedSums || $[59] !== totalAmount || $[60] !== uiLabels?.total_label) {
        t4 = selectionType === "multiple" && selectedCauseAreaId !== -1 && <><SmartDistributionForm suggestedSums={suggestedSums} totalAmount={totalAmount} causeAreas={causeAreas} causeAreaAmounts={causeAreaAmounts} causeAreaDistributionType={causeAreaDistributionType} smartDistributionContext={smartDistContext} causeAreaDisplayConfig={causeAreaDisplayConfig} />{causeAreas.filter(ca => ca.isActive || prefilledCauseAreaIds.has(ca.id)).filter(ca_0 => !causeAreaDisplayConfig?.below_line_cause_area_ids?.includes(ca_0.id)).map(ca_1 => <CauseAreaForm key={ca_1.id} causeArea={ca_1} isSingleSelection={false} suggestedSums={suggestedSums} causeAreaAmounts={causeAreaAmounts} orgAmounts={orgAmounts} causeAreaDistributionType={causeAreaDistributionType} showOperationsOption={false} operationsConfig={operationsConfig} causeAreaDisplayConfig={causeAreaDisplayConfig} smartDistributionContext={smartDistContext} />)}<GlobalCutToggle operationsConfig={operationsConfig} /><TotalAmountWrapper data-cy="total-amount-wrapper"><div>{uiLabels?.total_label}</div><div>{thousandize(totalAmount)} kr</div></TotalAmountWrapper></>;
        $[48] = causeAreaAmounts;
        $[49] = causeAreaDisplayConfig;
        $[50] = causeAreaDistributionType;
        $[51] = causeAreas;
        $[52] = operationsConfig;
        $[53] = orgAmounts;
        $[54] = prefilledCauseAreaIds;
        $[55] = selectedCauseAreaId;
        $[56] = selectionType;
        $[57] = smartDistContext;
        $[58] = suggestedSums;
        $[59] = totalAmount;
        $[60] = uiLabels?.total_label;
        $[61] = t4;
      } else {
        t4 = $[61];
      }
      t5 = selectionType === "single" && selectedCA && <>{selectedCA.id === operationsConfig?.operations_cause_area_id ? <OperationsCauseAreaForm causeArea={selectedCA} suggestedSums={suggestedSums} causeAreaAmounts={causeAreaAmounts} causeAreaDisplayConfig={causeAreaDisplayConfig} /> : <><CauseAreaForm causeArea={selectedCA} isSingleSelection={true} suggestedSums={suggestedSums} causeAreaAmounts={causeAreaAmounts} orgAmounts={orgAmounts} causeAreaDistributionType={causeAreaDistributionType} showOperationsOption={!operationsConfig?.excluded_cause_area_ids?.includes(selectedCA.id)} operationsConfig={operationsConfig} causeAreaDisplayConfig={causeAreaDisplayConfig} smartDistributionContext={smartDistContext} /></>}</>;
    }
    $[5] = causeAreaAmounts;
    $[6] = causeAreaDisplayConfig;
    $[7] = causeAreaDistributionType;
    $[8] = causeAreas;
    $[9] = dispatch;
    $[10] = enableRecurring;
    $[11] = enableSingle;
    $[12] = operationsConfig;
    $[13] = orgAmounts;
    $[14] = prefilledCauseAreaIds;
    $[15] = recurring;
    $[16] = selectedCauseAreaId;
    $[17] = selectionType;
    $[18] = smartDistContext;
    $[19] = suggestedSums;
    $[20] = text;
    $[21] = totalAmount;
    $[22] = uiLabels?.total_label;
    $[23] = T0;
    $[24] = T1;
    $[25] = T2;
    $[26] = t4;
    $[27] = t5;
    $[28] = t6;
    $[29] = t7;
  } else {
    T0 = $[23];
    T1 = $[24];
    T2 = $[25];
    t4 = $[26];
    t5 = $[27];
    t6 = $[28];
    t7 = $[29];
  }
  if (t7 !== Symbol.for("react.early_return_sentinel")) {
    return t7;
  }
  let t8;
  if ($[62] !== causeAreaAmounts || $[63] !== causeAreaDisplayConfig || $[64] !== causeAreaDistributionType || $[65] !== causeAreas || $[66] !== operationsConfig || $[67] !== selectedCauseAreaId || $[68] !== smartDistContext || $[69] !== suggestedSums || $[70] !== totalAmount) {
    t8 = selectedCauseAreaId === -1 && <><SmartDistributionForm suggestedSums={suggestedSums} totalAmount={totalAmount} causeAreas={causeAreas} causeAreaAmounts={causeAreaAmounts} causeAreaDistributionType={causeAreaDistributionType} smartDistributionContext={smartDistContext} causeAreaDisplayConfig={causeAreaDisplayConfig} /><GlobalCutToggle operationsConfig={operationsConfig} /></>;
    $[62] = causeAreaAmounts;
    $[63] = causeAreaDisplayConfig;
    $[64] = causeAreaDistributionType;
    $[65] = causeAreas;
    $[66] = operationsConfig;
    $[67] = selectedCauseAreaId;
    $[68] = smartDistContext;
    $[69] = suggestedSums;
    $[70] = totalAmount;
    $[71] = t8;
  } else {
    t8 = $[71];
  }
  let t9;
  if ($[72] !== T0 || $[73] !== t4 || $[74] !== t5 || $[75] !== t8) {
    t9 = <T0>{t4}{t5}{t8}</T0>;
    $[72] = T0;
    $[73] = t4;
    $[74] = t5;
    $[75] = t8;
    $[76] = t9;
  } else {
    t9 = $[76];
  }
  let t10;
  if ($[77] !== t6 || $[78] !== t9) {
    t10 = <div>{t6}{t9}</div>;
    $[77] = t6;
    $[78] = t9;
    $[79] = t10;
  } else {
    t10 = $[79];
  }
  const t11 = effectiveTotal <= 0;
  let t12;
  if ($[80] !== handleNext || $[81] !== nextButtonText || $[82] !== t11) {
    t12 = <ActionBar><NextButton disabled={t11} onClick={handleNext} data-cy="next-button">{nextButtonText}</NextButton></ActionBar>;
    $[80] = handleNext;
    $[81] = nextButtonText;
    $[82] = t11;
    $[83] = t12;
  } else {
    t12 = $[83];
  }
  let t13;
  if ($[84] !== T1 || $[85] !== t10 || $[86] !== t12) {
    t13 = <T1>{t10}{t12}</T1>;
    $[84] = T1;
    $[85] = t10;
    $[86] = t12;
    $[87] = t13;
  } else {
    t13 = $[87];
  }
  let t14;
  if ($[88] !== T2 || $[89] !== t13) {
    t14 = <T2>{t13}</T2>;
    $[88] = T2;
    $[89] = t13;
    $[90] = t14;
  } else {
    t14 = $[90];
  }
  return t14;
};
function _temp(state) {
  return state.donation;
}
function _temp2(state_0) {
  return state_0.layout.causeAreas;
}